import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {buildPageSchemaForTemplate} from './containerPage'
import {PrimerComponentHeroSchema} from './primerComponentHero'
import {PrimerComponentCardSchema} from './primerComponentCard'
import {PrimerComponentSubnavSchema} from './primerComponentSubnav'
import {RichTextSchema} from '../richText'

export const IndexFilterSchema = buildEntrySchemaFor('indexFilter', {
  fields: z.lazy(() =>
    z.object({
      groupName: z.string(),
      groupValue: z.string(),
      filterName: z.string(),
      filterValue: z.string(),
    }),
  ),
})

export type IndexFilter = z.infer<typeof IndexFilterSchema>

export const IndexCardSchema = buildEntrySchemaFor('indexCard', {
  fields: z.lazy(() =>
    z.object({
      card: PrimerComponentCardSchema.optional(),
      indexFilters: z.array(IndexFilterSchema).optional(),
    }),
  ),
})

export type IndexCard = z.infer<typeof IndexCardSchema>

export const TemplateIndexSchema = buildEntrySchemaFor('templateIndex', {
  fields: z.lazy(() =>
    z.object({
      subNav: PrimerComponentSubnavSchema.optional(),
      hero: PrimerComponentHeroSchema.optional(),
      cards: z.array(IndexCardSchema).optional(),
      filters: z.array(IndexFilterSchema).optional(),
      emptyStateDescription: RichTextSchema.optional(),
      spotlightCard: IndexCardSchema.optional(),
    }),
  ),
})

export const IndexPageSchema = buildPageSchemaForTemplate(TemplateIndexSchema)
export type IndexPage = z.infer<typeof IndexPageSchema>

export function toIndexPage(item: unknown): IndexPage {
  return IndexPageSchema.parse(item)
}
